export class OutingDetailsDto{
    public details: Details = new Details();
    public iterations: Iterations[] = [];
    public permissions: Permissions[] = [];   
}

export class Details{
    public id: string;
    public name: string;
    public createdByUser: string;
    public createdDate: string;
}

export class Iterations{
    public id: string;
    public startDate: Date;
    public cost: number;
    public courseName: string;
    public fullAddress: string;
}

export class Permissions{
    public id: string;
    public name: string;
    public firstName: string;
    public lastName: string;
}